import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Header, Footer } from '../../components/layout';
import { ArrowLeft } from 'lucide-react';
import { ToolbarButton } from '../../components/common';
import './PrivacyPolicy.css';

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();
  const lastUpdated = '2025년 1월 25일';

  return (
    <div className="page-container-white">
      <Header />
      
      <main className="privacy-policy-content">
        <div className="privacy-header">
          <ToolbarButton
            onClick={() => navigate(-1)}
            variant="default"
            className="mb-4"
          >
            <ArrowLeft className="w-4 h-4" />
            뒤로 가기
          </ToolbarButton>
          
          <h1 className="privacy-title">개인정보처리방침</h1>
          <p className="privacy-updated">최종 수정일: {lastUpdated}</p>
        </div>

        <div className="privacy-body">
          <section className="privacy-section">
            <h2>1. 개인정보의 처리 목적</h2>
            <p>
              Latte AI(이하 '서비스')는 다음의 목적을 위하여 개인정보를 처리합니다. 
              처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 
              이용 목적이 변경되는 경우에는 개인정보보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
            </p>
            <ul>
              <li>서비스 제공: AI 기반 이력서 작성 서비스 제공</li>
              <li>회원 관리: 회원제 서비스 이용에 따른 본인확인, 개인식별, 회원자격 유지·관리</li>
              <li>서비스 개선: 서비스 이용기록과 접속 로그 분석을 통한 서비스 개선</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>2. 개인정보의 처리 및 보유기간</h2>
            <p>
              서비스는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
            </p>
            <ul>
              <li>회원 정보: 회원 탈퇴 시까지</li>
              <li>서비스 이용 기록: 최대 3년</li>
              <li>관계 법령에 따른 보존이 필요한 경우 해당 법령에서 정한 기간</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>3. 처리하는 개인정보의 항목</h2>
            <p>서비스는 다음의 개인정보 항목을 처리하고 있습니다.</p>
            
            <h3>필수 항목</h3>
            <ul>
              <li>Google 계정 정보: 이메일 주소, 이름, 프로필 사진</li>
              <li>서비스 이용 기록: 접속 IP, 접속 시간, 서비스 이용 내역</li>
            </ul>
            
            <h3>선택 항목</h3>
            <ul>
              <li>이력서 작성 정보: 경력, 학력, 자격증, 기술 스택 등</li>
              <li>컨설팅 내용: AI와의 대화 내용</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>4. 개인정보의 제3자 제공</h2>
            <p>
              서비스는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 
              정보주체의 동의, 법률의 특별한 규정 등 개인정보보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
            </p>
          </section>

          <section className="privacy-section">
            <h2>5. 개인정보처리의 위탁</h2>
            <p>서비스는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
            <ul>
              <li>
                <strong>Google Cloud Platform</strong>
                <br />위탁업무: 데이터 저장 및 처리
                <br />보유기간: 회원탈퇴 시 또는 위탁계약 종료 시까지
              </li>
              <li>
                <strong>OpenAI</strong>
                <br />위탁업무: AI 기반 텍스트 생성 및 분석
                <br />보유기간: 처리 완료 후 즉시 삭제
              </li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>6. 정보주체와 법정대리인의 권리·의무 및 행사방법</h2>
            <p>정보주체는 서비스에 대해 언제든지 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
            <ul>
              <li>개인정보 열람 요구</li>
              <li>오류 등이 있을 경우 정정 요구</li>
              <li>삭제 요구</li>
              <li>처리정지 요구</li>
            </ul>
            <p>
              권리 행사는 서면, 전자우편 등을 통하여 하실 수 있으며, 
              서비스는 이에 대해 지체없이 조치하겠습니다.
            </p>
          </section>

          <section className="privacy-section">
            <h2>7. 개인정보의 파기</h2>
            <p>
              서비스는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 
              지체없이 해당 개인정보를 파기합니다.
            </p>
            <ul>
              <li>파기절차: 파기 사유가 발생한 개인정보를 선정하고, 개인정보보호책임자의 승인을 받아 개인정보를 파기합니다.</li>
              <li>파기방법: 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>8. 개인정보의 안전성 확보조치</h2>
            <p>서비스는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
            <ul>
              <li>개인정보의 암호화: 이용자의 비밀번호 등 중요 정보는 암호화되어 저장 및 관리됩니다.</li>
              <li>해킹 등에 대비한 기술적 대책: 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위해 보안프로그램을 설치하고 주기적인 갱신·점검을 합니다.</li>
              <li>개인정보에 대한 접근 제한: 개인정보를 처리하는 직원을 지정하고 별도의 비밀번호를 부여하여 접근을 제한합니다.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>9. 개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항</h2>
            <p>
              서비스는 정보주체의 이용정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다. 
              쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 
              이용자들의 컴퓨터 내의 하드디스크에 저장되기도 합니다.
            </p>
            <p>
              이용자는 웹 브라우저 옵션 설정을 통해 쿠키 허용, 차단 등을 결정할 수 있습니다. 
              다만, 쿠키 저장을 거부할 경우 서비스 이용에 어려움이 발생할 수 있습니다.
            </p>
          </section>

          <section className="privacy-section">
            <h2>10. 개인정보보호책임자</h2>
            <p>
              서비스는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 
              개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보보호책임자를 지정하고 있습니다.
            </p>
            <div className="contact-info">
              <p><strong>개인정보보호책임자</strong></p>
              <p>이메일: contact@latteis.com</p>
            </div>
          </section>

          <section className="privacy-section">
            <h2>11. 개인정보 처리방침 변경</h2>
            <p>
              이 개인정보처리방침은 {lastUpdated}부터 적용되며, 
              법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 
              변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.
            </p>
          </section>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;